import React, { useEffect, useState } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'datatables.net-dt/css/jquery.dataTables.min.css';
import 'datatables.net-dt/js/dataTables.dataTables';
import 'jquery/dist/jquery.min.js';
import $ from 'jquery';
import { Trash2 } from 'react-feather';
import '../../Styles/Annotator/AdvicesComponent.css';
import { deleteIgnoreListItem, getIgnoreListData } from '../../API/annotator';

function IgnoreListViewComponent() {
    const [ignoreListData, setIgnoreListData] = useState([]);

    useEffect(async () => {
        let ignoreList = await getIgnoreListData().then(function (result) {
            return JSON.stringify(result);
        });

        ignoreList = JSON.parse(ignoreList);

        const ignoreListDataValues = ignoreList.map((o) => (
            <tr key={o.objectID}>
                <td>{o.objectID}</td>
                <td>{o.Annotation}</td>
                <td>{o.type}</td>
                <td>
                    <button onClick={() => deleteIgnoreListItem(o.objectID)} className="btn btn-danger">
                        <Trash2 />
                    </button>
                </td>
            </tr>
        ));

        setIgnoreListData(ignoreListDataValues);

        //initialize datatable
        $(document).ready(function () {
            let table = $('#ignoreListTable').DataTable({
                pageLength: 100,
                language: {
                    fontcolor: 'white',
                    url: 'https://cdn.datatables.net/plug-ins/1.10.24/i18n/German.json' // German Language - DataTable Plugin
                }
            });
            table.draw();
        });
    }, []);

    return (
        <div className="container handwai-dark">
            <table id="ignoreListTable" className="table advicesTableText" data-page-length="100">
                <thead>
                    <tr>
                        <th>ID</th>
                        <th>Annotation</th>
                        <th>Kategorie</th>
                        <th>Aktion</th>
                    </tr>
                </thead>
                <tbody>{ignoreListData}</tbody>
            </table>
        </div>
    );
}

export default IgnoreListViewComponent;
